import { render, staticRenderFns } from "./TheoryRating.vue?vue&type=template&id=173faaac"
import script from "./TheoryRating.vue?vue&type=script&lang=js"
export * from "./TheoryRating.vue?vue&type=script&lang=js"
import style0 from "./TheoryRating.vue?vue&type=style&index=0&id=173faaac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports